import {
	Button,
	Modal,
	ModalBody,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Text,
	useDisclosure,
} from '@chakra-ui/react';
import { NAVIGATE } from 'constant/navigation';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import resetStore from 'store/action';

const SessionTimeout = ({ timeoutDuration }) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
	const { isOpen, onOpen, onClose } = useDisclosure();
	const [counter, setCounter] = useState(45);

	const timerRef = useRef(null);
	const countdownIntervalRef = useRef(null);
	const isModalOpenRef = useRef(false);

	const logout = useCallback(() => {
		clearTimers();
		onClose();
		isModalOpenRef.current = false;
		resetStore(dispatch);
		navigate(NAVIGATE.SIGN_IN);
	}, [dispatch, navigate, onClose]);

	const clearTimers = () => {
		clearTimeout(timerRef.current);
		clearInterval(countdownIntervalRef.current);
	};

	const startCountdown = () => {
		setCounter(45);
		onOpen();
		isModalOpenRef.current = true;

		countdownIntervalRef.current = setInterval(() => {
			setCounter((prev) => {
				if (prev <= 1) {
					clearTimers();
					logout();
					return 0;
				}
				return prev - 1;
			});
		}, 1000);
	};

	const resetTimer = () => {
		clearTimers();
		onClose();
		isModalOpenRef.current = false; // 👈
		timerRef.current = setTimeout(startCountdown, timeoutDuration);
	};

	const handleActivity = () => {
		if (!isModalOpenRef.current) {
			resetTimer();
		}
	};

	const handleContinue = () => {
		clearTimers();
		resetTimer();
		onClose();
		isModalOpenRef.current = false;
	};

	useEffect(() => {
		if (isLoggedIn) {
			resetTimer();
			window.addEventListener('mousemove', handleActivity);
			window.addEventListener('keydown', handleActivity);
			window.addEventListener('scroll', handleActivity);
		}

		return () => {
			clearTimers();
			window.removeEventListener('mousemove', handleActivity);
			window.removeEventListener('keydown', handleActivity);
			window.removeEventListener('scroll', handleActivity);
		};
	}, [isLoggedIn]);

	return (
		<Modal isOpen={isOpen && isLoggedIn} onClose={handleContinue} isCentered>
			<ModalOverlay />
			<ModalContent my={7}>
				<ModalHeader textAlign={'center'}>
					Advertencia de tiempo de sesión
				</ModalHeader>
				<ModalBody>
					<Text textAlign={'center'} mb={4}>
						Tu sesión expirará en {counter} segundos debido a inactividad.
						¿Deseas continuar con tu sesión?
					</Text>
				</ModalBody>
				<ModalFooter display='flex' justifyContent='center' gap={4} mt={4}>
					<Button color={'white'} variant='brand' onClick={handleContinue}>
						Continuar sesión
					</Button>
					<Button variant='light' onClick={logout}>
						Cerrar sesión
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default SessionTimeout;
